/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    excluir(manutencao) {
        return axiosJwt.delete(`${api}/contratos/${manutencao.contratoId}/manutencoes/${manutencao.idManutencaoContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(manutencao) {
        return axiosJwt.post(`${api}/contratos/${manutencao.contratoId}/manutencoes`, manutencao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizar(contratoId, idManutencaoContrato, manutencao) {
        return axiosJwt.put(`${api}/contratos/${contratoId}/manutencoes/${idManutencaoContrato}`, manutencao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterManutencoes(contratoId) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/manutencoes`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterManutencao(contratoId, idManutencaoContrato) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/manutencoes/${idManutencaoContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
}
